import { background, visible, backgroundGradient } from '../../shared/stylesheets/background.css'
import { imageHandler } from './image'
import { videoHandler } from './video'
import { mapHandler } from './map'
import { polopolyIdHandler } from './polopoly-image'
import { fullscreenVideoHandler } from './fullscreen-video'
import { bylineHandler, seeMoreHandler } from './byline'
import { getLogo } from '../utils/getLogo'
import { getShareButtons } from '../utils/getShareButtons'
import { getInitialMuteButton } from '../utils/muteButtons'

const sectionHandlers = [fullscreenVideoHandler, mapHandler, imageHandler, polopolyIdHandler, videoHandler, bylineHandler, seeMoreHandler]

export function loadSections(sectionElements, backgroundContainer, overlayContainer) {
  [...sectionElements]
    .forEach((card, idx) => {
      const handler = sectionHandlers.find((handler) => !!card.getAttribute(handler.property))

      const elem = handler.load(card)
      elem.className = background
      getShareButtons()

      backgroundContainer.appendChild(elem)
      backgroundContainer.setAttribute('aria-hidden', 'true')

      if (handler.init) {
        try {
          handler.init(card, elem)
        } catch (e) {
          console.error('Error initializing background', e)
        }
      }

      if (idx === 0) {
        elem.className = `${background} ${visible}`
      }
      if (card.getAttribute('data-background-gradient')) {
        elem.classList.add(backgroundGradient)
      }
    })



    overlayContainer.innerHTML += `${getLogo()} ${getShareButtons()} ${getInitialMuteButton()}`
  }



// WEBPACK FOOTER //
// ./src/client/sections/index.js